'use client'

import { Typography } from 'antd'
import {
  AddressLine,
  GeoLocationAddress,
  GetDirectionsLink,
} from '@/src/components'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { GeoLocation, Physician } from '@/src/interfaces'

const { Text } = Typography

export const PhysicianAddress = ({
  physician,
  geoLocation,
  isProfileCard,
}: {
  physician: Physician
  geoLocation?: GeoLocation | null
  isProfileCard?: boolean
}) => {
  return (
    <>
      {geoLocation && physician.geo_distance_miles ? (
        <GeoLocationAddress
          physician={physician}
          isProfileCard={isProfileCard}
        />
      ) : (
        <>
          {isProfileCard ? (
            <>
              <AddressLine
                physicianAddress={physician.address}
                physicianCity={physician.city}
                physicianState={physician.state}
                physicianZip={physician.zip}
                isProfileCard={true}
              />
              <GetDirectionsLink physician={physician} isProfileCard={true} />
            </>
          ) : (
            <>
              <div className='flex flex-col'>
                <Text
                  type='secondary'
                  className='custom-physician-bio-text ant-typography'
                >
                  <FontAwesomeIcon icon='location-dot' className='mr-2' />
                  {physician.address}
                </Text>
                <GetDirectionsLink physician={physician} />
              </div>
            </>
          )}
        </>
      )}
    </>
  )
}
